import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as sessionActions from '../../../actions/session';

class LogoutButton extends React.Component {

    _logout(e) {
        e.preventDefault();
        this.props.logout(() => this.props.history.push('/login'));
        this.props.onClick();
    }

    render() {
        return (
            <a href="" className={this.props.className} onClick={this._logout.bind(this)}>
                { this.props.children }
            </a>
        )
    }
}

LogoutButton.defaultProps = {
    className: '',
    onClick: () => {}
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        logout(successCallback) {
            return dispatch(sessionActions.logout(successCallback));
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoutButton));